import type { SessionContextType } from '../contexts/SessionContext';

/**
 * Visibility state for the Invoicing reporting tab.
 * - `none`: invoicing is off for the org, or the user lacks invoicing-reporting.
 * - `reporting-tab`: full-time org with invoicing enabled → add an Invoicing tab.
 * - `invoicing-only`: invoicing-only org → Reporting suppresses Overview/etc.; Invoicing tab only,
 *   plus Inventory when inventory reporting is available.
 */
export type InvoicingReportingVisibility = 'none' | 'reporting-tab' | 'invoicing-only';

export function getInvoicingReportingVisibility(
    ctx: SessionContextType | undefined
): InvoicingReportingVisibility {
    if (!ctx || ctx.isAuthenticated !== true) return 'none';
    if (ctx.invoicingEnabled !== true) return 'none';
    if (!ctx.permissions?.includes('invoicing-reporting')) return 'none';
    if (ctx.organizationMode === 'invoicing') return 'invoicing-only';
    return 'reporting-tab';
}
